import Enum from "../../../enums/Enum";

const EnumConsecutiveDaysOrSplitWeek = new Enum({
    CONSECUTIVE_DAYS: "Consecutive Days",
    SPLIT_WEEK: "Split Week",
    NO_PREFERENCE: "No Preference"
});

export default EnumConsecutiveDaysOrSplitWeek;